import type { AxiosRequestConfig, Canceler } from 'axios'
import axios from 'axios'

let pendingMap: Map<string, Canceler> = new Map()

const getRequestIdentifier = (config: AxiosRequestConfig) => {
  if (config.method?.toLowerCase() === 'get') {
    return `get&${encodeURIComponent(config.url + JSON.stringify(config.params))}`
  }
  return `${config.method}&${encodeURIComponent(config.url + JSON.stringify(config.data))}`
}

export class AxiosCanceler {
  addPending(config: AxiosRequestConfig) {
    const identifier = getRequestIdentifier(config)
    this.removePending(config)
    config.cancelToken =
      config.cancelToken ||
      new axios.CancelToken((cancel) => {
        if (pendingMap.has(identifier) === false) {
          pendingMap.set(identifier, cancel)
        }
      })
  }
  removePending(config: AxiosRequestConfig) {
    const identifier = getRequestIdentifier(config)
    if (pendingMap.has(identifier)) {
      const canceler = pendingMap.get(identifier)
      canceler && canceler('重复请求：' + identifier)
      pendingMap.delete(identifier)
    }
  }
  static removeAllPendings() {
    pendingMap.forEach((canceler, identifier) => {
      canceler && canceler(identifier)
    })
    pendingMap.clear()
  }
  reset() {
    pendingMap = new Map()
  }
}
